import React from 'react';
import { Flex, Icon, Text } from '@qga/roo-ui/components';

import Skeleton from '@shared/v2/components/Skeleton';

export type MaxOccupantsProps = {
  maxOccupants: number | undefined;
};

const MaxOccupants = ({ maxOccupants }: MaxOccupantsProps) => {
  return (
    <Skeleton mt="2" mb="3" height="1.25rem" width="90px">
      {maxOccupants ? (
        <Flex
          mt="1"
          mb="2"
          data-testid="ROOM_MAX_OCCUPANTS"
          alignItems="center"
        >
          <Icon mr="1" size="24px" name="people" color="greys.steel" />
          <Text lineHeight="1.5" color="greys.steel" fontSize="sm">
            {`Sleeps ${maxOccupants}`}
          </Text>
        </Flex>
      ) : null}
    </Skeleton>
  );
};

export default MaxOccupants;
